import { render, staticRenderFns } from "./GameScreenSidebar.vue?vue&type=template&id=1b47613f&scoped=true&"
import script from "./GameScreenSidebar.vue?vue&type=script&lang=js&"
export * from "./GameScreenSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GameScreenSidebar.vue?vue&type=style&index=0&id=1b47613f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47613f",
  null
  
)

export default component.exports